export default {
  IS_2FA_REQUIRED: 'IS_2FA_REQUIRED',
  IS_BAD_CODE: 'IS_BAD_CODE',
  IS_BAD_CREDENTIALS: 'IS_BAD_CREDENTIALS',
  IS_DISABLED: 'IS_DISABLED',
  IS_INVALID_RESET: 'IS_INVALID_RESET',
  IS_LOCKED: 'IS_LOCKED',
  IS_MISSING_CSRF: 'IS_MISSING_CSRF',
  IS_RESET: 'IS_RESET',
  IS_SENT: 'IS_SENT',
  IS_SINGLE_SESSION: 'IS_SINGLE_SESSION',
  IS_UNAUTHENTICATED: 'IS_UNAUTHENTICATED',
  IS_VALID_CODE: 'IS_VALID_CODE',
  IS_VALID_LOGIN: 'IS_VALID_LOGIN',
  NOT_FOUND: 'NOT_FOUND',
  TRYING_TOO_OFTEN: 'TRYING_TOO_OFTEN',
};
